<template>
  <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.596 11.906 3.47 8.78 2.404 9.836l4.192 4.193 9-9L14.54 3.97l-7.943 7.935z" />
  </svg>
</template>
